




















































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { VuetifyGoToOptions } from 'vuetify'
import Stickyfill from 'stickyfilljs'
import debounce from 'lodash/debounce'
import About from './components/About.vue'
import Contact from './components/Contact.vue'
import Impression from './components/Impression.vue'

@Component({
  components: {
    About,
    Contact,
    Impression,
  },
})
export default class App extends Vue {
  $refs!: {
    navigation: HTMLElement
    about: Vue
    impression: Vue
    contact: Vue
  }

  drawer: boolean = false
  goingTo: boolean = false

  scrollOptions: VuetifyGoToOptions = {
    duration: 600,
    offset: 64,
    easing: 'easeOutCubic',
  }

  get toolBarBinding(): { [key: string]: any } {
    const binding: { [key: string]: any } = {}

    if (this.$vuetify.breakpoint.smAndDown) {
      binding['scroll-off-screen'] = true
    }

    return binding
  }

  get toolBarLayoutBinding(): { [key: string]: any } {
    const binding: { [key: string]: any } = {}

    if (this.$vuetify.breakpoint.smAndDown) {
      binding['px-2'] = true
    }

    return binding
  }

  get footerBinding(): { [key: string]: any } {
    const binding: { [key: string]: any } = {}

    if (this.$vuetify.breakpoint.smAndDown) {
      binding.height = '128'
    } else {
      binding.height = '64'
    }

    return binding
  }

  get footerLayoutBinding(): { [key: string]: any } {
    const binding: { [key: string]: any } = {}

    if (this.$vuetify.breakpoint.smAndDown) {
      binding['px-2'] = true
    }

    return binding
  }

  get footerInfoLayoutBinding(): { [key: string]: any } {
    const binding: { [key: string]: any } = {}

    if (this.$vuetify.breakpoint.smAndDown) {
      binding.column = true
    }

    return binding
  }

  mounted(): void {
    Stickyfill.add(this.$refs.navigation)
  }

  async goTo(target: string, options: VuetifyGoToOptions = this.scrollOptions): Promise<void> {
    try {
      this.goingTo = true
      await this.$vuetify.goTo(target, options)
      this.goingTo = false
    } catch (err) {
      console.error('could not go to', target, err)
    }
  }

  onScroll = debounce(async (event: UIEvent) => {
    const aboutEl = this.$refs.about.$el
    const impressionEl = this.$refs.impression.$el
    const contactEl = this.$refs.contact.$el
    const atTop = window.scrollY === 0
    const atBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight

    if (this.$vuetify.breakpoint.smAndDown || atTop || atBottom || this.goingTo || !aboutEl || !impressionEl) {
      return
    }

    const scrollOptions = JSON.parse(JSON.stringify(this.scrollOptions))
    scrollOptions.duration = 300

    const offsetTop = window.scrollY
    const windowBottom = offsetTop + window.innerHeight
    const impressionRect = impressionEl.getBoundingClientRect()
    const impressionHeight = impressionRect.height
    const impressionHeightHalf = impressionHeight / 2

    try {
      if (windowBottom < window.innerHeight * 1.5) {
        await this.goTo('body', scrollOptions)
      } else if (
        windowBottom >= window.innerHeight * 1.5 &&
        windowBottom < window.innerHeight * 1.5 + impressionHeightHalf
      ) {
        await this.goTo('#impression', scrollOptions)
      } else if (windowBottom >= window.innerHeight * 1.5 + impressionHeight) {
        await this.goTo('#contact', scrollOptions)
      }
    } catch (err) {
      console.error('could not scroll to', err)
    }
  }, 200)
}
